import {
    GET_VARIABLE_REMUNERATION,
    VARIABLE_REMUNERATION_LOADING,
    VARIABLE_REMUNERATION_DATA,
    VARIABLE_REMUNERATION_ERROR,
} from 'store/constants'

export const initialState = {
    variableRemunerationData: {},
    variableRemunerationError: false,
    orderVariableRemuneration: {},
    loading: false,
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_VARIABLE_REMUNERATION:
            return { ...state, variableRemunerationData: action.payload }
        case VARIABLE_REMUNERATION_DATA:
            return { ...state, variableRemunerationData: action.payload }
        case VARIABLE_REMUNERATION_LOADING:
            return { ...state, loading: action.payload }
        case VARIABLE_REMUNERATION_ERROR:
            return { ...state, variableRemunerationError: action.payload }
        default:
            return state
    }
}
